import { blockEl, unblockEl } from "./Block";
import Swiper from 'swiper/bundle';
import SelectOrder from "./SelectOrder";
import {createElement} from "../util/utils";

const { __ } = wp.i18n;

export default class ProductList {
  constructor(args)
  {
    this.productWrap = document.querySelector('#productWrap');

    this.productRow = this.productWrap ? this.productWrap.querySelector('.products') : null;

    if(!this.productRow) {
      return;
    }
    this.bp = 'min-width: 992px';
    this.breakpoint = window.matchMedia(`(${this.bp})`);
    this.sortOffcanvas = args.sortOffcanvas;
    this.filterOffcanvas = args.filterOffcanvas;
    this.sort = new SelectOrder(this.bp, this.sortOffcanvas);
    this.filter = args.filter;
    this.slider = null;
    this.resultCount = document.querySelector('#resultsCount');
    this.productH = document.querySelector('#productHelper');
    this.productHPrev = this.productH ? this.productH.previousElementSibling : undefined;
    this.loadMoreWrap = document.querySelector('#product-load-more');
    this.filterSelectedSidebar = document.querySelector('.filter-selected-sidebar');

    this.initSlider();
    this.setProductHelperCardPosition();
    this.attachHandlers();
  }

  attachHandlers()
  {

    this.productWrap.addEventListener('click', this.onLoadButtonClick.bind(this));

    document.body.addEventListener('palram_order_set', this.onOrderSet.bind(this));
    document.body.addEventListener('palram_filters_changed', this.onFiltersChanged.bind(this));

    if(undefined !== this.filterOffcanvas.el) {
      this.filterOffcanvas.el.addEventListener('show.bs.offcanvas', this.filter.onFilterOpen);
      this.filterOffcanvas.el.addEventListener('hide.bs.offcanvas', this.filter.onFilterClose);
    }

    //Close filters after apply event

    document.body.addEventListener('palram_filters_applied', () => {
      this.filterOffcanvas.hide();
    })
    try {
      // Chrome & Firefox
      this.breakpoint.addEventListener('change', this.setProductHelperCardPosition.bind(this));
    } catch (e1) {
      try {
        // Safari
        this.breakpoint.addListener(this.setProductHelperCardPosition.bind(this));
      } catch (e2) {
      }
    }
  }

  initSlider()
  {
    let slider = document.querySelector('#product-category-slider');

    if(!(slider && slider.dataset.enabled === 'true')) {
      return;
    }

    new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        grabCursor: true,
        zoomEffect: true,
        pagination: {
          el: '#product-category-slider-pagination',
          type: 'bullets',
          bulletClass: 'pagination-line',
          bulletActiveClass: 'active',
          clickable: true,
        },
        breakpoints: {
          992: {
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      },
    });
  }

  setProductHelperCardPosition()
  {
    let prevEl;

    if( ! [this.productH, this.productHPrev, this.filter.getForm()].every( item => ![undefined, null].includes(item) ) ) {
      return;
    }

    if(this.breakpoint.matches) {
      prevEl = this.filter.getForm();
    } else {
      prevEl = this.productHPrev;
    }

    prevEl.parentNode.insertBefore(this.productH, prevEl.nextSibling);
  }

  async onLoadButtonClick(event)
  {
    if(!event.target.classList.contains('ajax-load-posts')) {
      return;
    }

    event.preventDefault();
    const page = event.target.dataset.page || 0;

    this.setPageQuery(page);

    this.getFilteredProducts(false);
  }

  setPageQuery(page = 0)
  {
    let pathname = window.location.pathname.replace(/\/$/, '');
    const re = /\/page\/\d+/;

    if(re.test(pathname)) {
      pathname = pathname.replace(re, page > 0 ? `/page/${page}` : '');
    } else if(page > 0) {
      pathname += `/page/${page}`;
    }

    window.history.replaceState({}, '', `${pathname}/${window.location.search}`);
  }

  async onOrderSet()
  {
    this.getFilteredProducts(true);
  }

  async onFiltersChanged()
  {
    this.getFilteredProducts(true);
  }


  async getFilteredProducts(override)
  {
    blockEl(this.filter.getForm(), this.sort.getForm(), this.productRow);

    if(override) {
      //reset to first page
      this.setPageQuery(0);
    }

    try {
      let response = await this.getPage();

      if(response) {
        this.updatePageWithResults(response, override);
        this.initSlider();
      }

    } catch (e) {
      this.requestError(e);
    } finally {
      unblockEl(this.filter.getForm(), this.sort.getForm(), this.productRow);
    }
  }

  updatePageWithResults(results, override)
  {
    const parser = new DOMParser();
    const doc = parser.parseFromString(results, 'text/html');
    const resultCount = doc.querySelector('#resultsCount');
    let productRow = doc.querySelector('.products');
    let products;

    if(override) {

      //Update product helper
      const productH = doc.querySelector('#productHelper');

      //Update product prev
      this.productHPrev = productH ? productH.previousElementSibling : undefined;

      if(this.breakpoint.matches) {
        //On desktop remove helper because it is in filter column
        if(productH) {
          productH.remove();
        }
      } else {
        //update productDh with new item
        this.productH = productH;
      }

      //Update selected filters on sidebar
      //
      // const filterSelectedSidebar = doc.querySelector('.filter-selected-sidebar');
      //
      // if(this.filterSelectedSidebar && filterSelectedSidebar) {
      //   this.filterSelectedSidebar.replaceWith(filterSelectedSidebar);
      //   this.filterSelectedSidebar = filterSelectedSidebar;
      // }

      //Update sort

      let newSort = doc.querySelector('#productSort');
      this.sortOffcanvas.el.innerHTML = newSort ? newSort.innerHTML : '';
      if(newSort) {
        this.sort = new SelectOrder(this.bp, this.sortOffcanvas);
      }

      //Update products
      if(!productRow) {
        productRow = createElement({
          classes: ['products', 'row'],
          innerHTML: `<p class="col-12 woocommerce-info">${__( 'No products were found matching your selection.', 'woocommerce' )}</p>`,
        });
      }

      this.productRow.replaceWith(productRow);
      this.productRow = productRow;
    } else {
      products = productRow.querySelectorAll('.product');

      if(products && products.length > 0) {
        this.productRow.append(...products);
      }
    }

    //Update results count and desktop active filters
    if(this.resultCount && resultCount) {
      this.resultCount.replaceWith(resultCount);
      this.resultCount = resultCount;
    }

    //Update filters form

    const filterForm = this.filter.getForm();
    const newFilterForm = doc.querySelector('#productFiltersForm');

    if(filterForm && newFilterForm) {
      filterForm.replaceWith(newFilterForm);
      //Re init filters
      this.filter.init();
    }

    //Update load more button

    this.loadMoreWrap = document.querySelector('#product-load-more');

    const loadMoreWrap = doc.querySelector('#product-load-more');

    if(loadMoreWrap) {
      if(this.loadMoreWrap) {
        this.loadMoreWrap.replaceWith(loadMoreWrap);
      } else {
        this.productWrap.appendChild(loadMoreWrap);
      }
      this.loadMoreWrap = loadMoreWrap;
    }

    document.body.dispatchEvent(new CustomEvent('products_loaded', {
      detail: {
        products,
      }
    }))
  }


  async getPage()
  {
    const response = await fetch(window.location.href, {
      method: 'GET',
    });
    return await response.text();
  }


  requestError(error) {
    console.error(error);
  };

}
